import { oktaGet } from '../oktaRequestWrapper';
import { ApiRoutes } from '../apiRoutes';
import { useQuery } from 'react-query';
import { generatePath } from 'react-router-dom';
import {
  SearchInvoiceActivitiesRequest,
  SearchInvoiceActivities,
} from '@/app/features/DebtorPortal/InvoiceDetail/invoiceDetail.types';

export const useGetInvoiceActivities = (request: SearchInvoiceActivitiesRequest) =>
  useQuery({
    queryKey: ['invoiceActivities', request.assetId],
    enabled: request.assetId > 0,
    queryFn: async (): Promise<SearchInvoiceActivities[]> => {
      const route = generatePath(ApiRoutes.SearchInvoiceActivities, {
        assetId: request.assetId.toString(),
      });
      const response = await oktaGet<SearchInvoiceActivities[]>(route);
      return response.data;
    },
  });
